import { useTranslation } from 'react-i18next';
import { AccountType } from '@shared/api/rest/accounts';
import { Button, Icon, Text } from '@shared/widgets';
import FilledTrashIcon from '@assets/icons/filled-trash.svg';

interface PropsType {
  onClose: () => void;
  id: number;
  type: AccountType;
  onDelete: (id: number) => void;
}

export const ModalDeleteConfirmation = (props: PropsType) => {
  const { t } = useTranslation('userManagement');

  const type =
    props.type === AccountType.Card
      ? t('user.info.modals.confirmationDelete.accountType.card')
      : t('user.info.modals.confirmationDelete.accountType.account');
  return (
    <div className='fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50'>
      <div className='w-full max-w-[556px] bg-white px-24 py-14 shadow-lg dark:bg-eerie-black'>
        <Icon icon={<FilledTrashIcon />} className='mb-6 flex justify-center' color='primary' />
        <div className='text-center'>
          <Text className='mb-2' weight='semibold' size='2xl'>
            {t('user.info.modals.confirmationDelete.title', { type })}
          </Text>
          <Text className='mb-6'>{t('user.info.modals.confirmationDelete.description', { type })}</Text>
          <div className='flex justify-center gap-3'>
            <Button color='outlined' fullWidth onClick={props.onClose}>
              {t('buttons.cancel', { ns: 'common' })}
            </Button>
            <Button color='primary' fullWidth onClick={() => props.onDelete(props.id)}>
              {t('user.info.modals.confirmationDelete.buttons.delete', { type })}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
